import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import apiClient from '../../api/axiosConfig'; // استدعاء خدمتنا الجديدة
import './Details.css';
import { IoChevronBackOutline } from "react-icons/io5";

function Details() {
  const { jobId } = useParams(); // الحصول على ID الوظيفة من الرابط
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJobDetails = async () => {
      setLoading(true);
      setError(null);
      try {
        // ==== تم استبدال منطق Firebase بهذا السطر ====
        const response = await apiClient.get(`/jobs/${jobId}`);
        // البيانات موجودة داخل response.data.data
        setJob(response.data.data);
      } catch (err) {
        console.error("Error fetching job details:", err);
        setError("فشل تحميل تفاصيل الوظيفة. قد تكون غير متوفرة.");
      } finally {
        setLoading(false);
      }
    };

    if (jobId) {
      fetchJobDetails();
    }
  }, [jobId]);

  // دالة لعرض النصوص المنسقة القادمة من Summernote
  const renderHTML = (htmlString) => {
    if (!htmlString) return <p>لا توجد معلومات متاحة.</p>;
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };

  // عرض حالة التحميل
  if (loading) {
    return (
        <section className='job-details' dir='rtl'>
          <div className='container text-center py-5'>
            <p>جاري تحميل التفاصيل...</p>
          </div>
        </section>
    );
  }

  // عرض حالة الخطأ
  if (error) {
    return (
        <section className='job-details' dir='rtl'>
          <div className='container text-center py-5'>
            <p className='text-danger'>{error}</p>
          </div>
        </section>
    );
  }

  // إذا لم يتم العثور على الوظيفة
  if (!job) {
    return (
        <section className='job-details' dir='rtl'>
          <div className='container text-center py-5'>
            <p>لم يتم العثور على الوظيفة المطلوبة.</p>
          </div>
        </section>
    );
  }

  return (
      <section className='job-details' dir='rtl'>
        <div className='container'>
          <div className='job-cont'>
            <h2>وصف الوظيفة</h2>
            <div className="line"></div>
            {/* استخدام أسماء الحقول الجديدة ودالة عرض HTML */}
            {renderHTML(job.full_description)}
          </div>
          <div className='job-cont'>
            <h2>متطلبات الوظيفة</h2>
            <div className="line"></div>
            {renderHTML(job.requirements)}
          </div>
          <div className='job-cont'>
            <h2>مميزات الوظيفة</h2>
            <div className="line"></div>
            {renderHTML(job.benefits)}
          </div>
          <div className='job-cont'>
            <h2>معلومات الوظيفة</h2>
            <div className="line"></div>
            {renderHTML(job.info)}
          </div>

          {/* ==== تم تعديل هذا الرابط ليمرر ID الوظيفة ==== */}
          <Link to={`/applier?job_id=${job.id}`} className='applyForJob'>
            سجل فى الوظيفة
            <IoChevronBackOutline />
          </Link>
        </div>
      </section>
  );
}

export default Details;